export default __webpack_public_path__ + "assets/whosincharge.a6f70103.png";